export default __webpack_public_path__ + "svg/calendar/2025/7/noviembre.svg?170928db";